<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            {{
              $route.params.id
                ? "Edit Insurance and Dependents"
                : "New Insurance and Dependents"
            }}
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form id="saveForm" @submit.prevent="save"></form>
    <div class="form-group row align-items-center">
      <label class="col-md-3 mb-0">Employee Name (Emp ID)</label>
      <div class="col-md-7 pl-md-0">
        <Select2
          v-model="userId"
          :options="employees"
          v-if="role == 'admin' && !$route.params.id"
          required
          form="saveForm"
        />
        <span v-else>{{ employeeName }}</span>
      </div>
    </div>
    <div class="form-group row align-items-center">
      <label class="col-md-3 mb-0">Year</label>
      <div class="col-md-7 pl-md-0">
        <select
          class="custom-select"
          v-model="year"
          required
          v-if="!this.isNewEmployee"
          form="saveForm"
          @change="getEmployeeDependentsByCategory"
        >
          <option value="" v-if="!$route.params.id">-- Please Select --</option>
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
        <span v-if="this.isNewEmployee">{{ this.year }}</span>
      </div>
    </div>
    <div class="form-group row align-items-center">
      <label class="col-md-3 mb-0">Type of Insurance</label>
      <div class="col-md-7 pl-md-0">
        <select class="custom-select" v-model="typeId" required form="saveForm">
          <option value="" v-if="!$route.params.id">-- Please Select --</option>
          <option v-for="item in types" :key="item.Id" :value="item.Id">
            {{ item.Description }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group row align-items-center">
      <label class="col-md-3 mb-0">Enrolment Category</label>
      <div class="col-md-7 pl-md-0">
        <select
          class="custom-select"
          v-model="categoryId"
          required
          @change="getEmployeeDependentsByCategory"
          form="saveForm"
        >
          <option value="" v-if="!$route.params.id">-- Please Select --</option>
          <option v-for="item in categories" :key="item.Id" :value="item.Id">
            {{ item.Description }}
          </option>
        </select>
      </div>
    </div>
    <div
      class="form-group row align-items-center"
      v-if="!isSpouseOnlySelected && categoryId"
    >
      <label class="col-md-3 mb-0">Number of Children</label>
      <div class="col-md-7 pl-md-0">
        <span>{{ noOfChildren }}</span>
      </div>
    </div>
    <div class="form-group row align-items-center">
      <label class="col-md-3 mb-0">Admin Instructions</label>
      <div class="col-md-7 pl-md-0">
        <textarea
          class="form-control"
          rows="10"
          readonly
          v-html="enrolmentPeriod.Instruction"
        ></textarea>
      </div>
    </div>

    <!-- Dependents Table -->
    <div class="row mt-4 mb-3" v-if="categoryId && dependents && dependents.length">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th>Dependent Name</th>
                <th>Dependent<br />Relationship</th>
                <th>Dependent<br />Marital Status</th>
                <th>Is your child on<br />full-time studies?</th>
                <th>Is your child on<br />National Service?</th>
                <th>Dependent<br />IC Number</th>
                <th>Dependent<br />Nationality</th>
                <th>Dependent<br />Identity Type</th>
                <th>Dependent<br />Gender</th>
                <th>Dependent<br />Birthday</th>
                <th>Dependent<br />Age</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in dependents" :key="item.Id">
                <td>{{ item.Name }}</td>
                <td>{{ item.Relationship }}</td>
                <td>
                  <select
                    class="custom-select custom-select-sm"
                    v-model="item.MaritalStatus"
                    form="saveForm"
                    required
                  >
                    <option value="">-- Please Select --</option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Widowed">Widowed</option>
                    <option value="Divorced">Divorced</option>
                    <option value="Partnership">Partnership</option>
                    <option value="Separated">Separated</option>
                  </select>
                </td>
                <td>
                  <select
                    v-if="item.Relationship == 'Child'"
                    class="custom-select custom-select-sm"
                    v-model="item.FullTimeInput"
                    form="saveForm"
                    required
                  >
                    <option value="">-- Please Select --</option>
                    <option value="True">Yes</option>
                    <option value="False">No</option>
                  </select>
                </td>
                <td>
                  <select
                    v-if="item.Relationship == 'Child'"
                    class="custom-select custom-select-sm"
                    v-model="item.NationalServiceInput"
                    form="saveForm"
                    required
                  >
                    <option value="">-- Please Select --</option>
                    <option value="True">Yes</option>
                    <option value="False">No</option>
                  </select>
                </td>
                <td>{{ item.Ic }}</td>
                <td>{{ item.Nationality }}</td>
                <td>{{ item.IdentityType }}</td>
                <td>{{ item.GenderDisplay }}</td>
                <td>{{ item.BirthdayDisplay }}</td>
                <td>{{ item.AgeDisplay }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Dependents Table -->

    <div class="row">
      <div class="col-md-3">
        <button type="button" class="btn btn-secondary" @click="$router.go(-1)">
          <i class="fa fa-reply mr-2"></i>Back
        </button>
      </div>
      <div class="col-md-7 text-right">
        <button
          type="submit"
          :class="isValid ? 'btn btn-primary' : 'btn btn-secondary'"
          form="saveForm"
          :disabled="!isValid"
        >
          <i v-if="$route.params.id" class="fa fa-save"></i>
          <i v-else class="fa fa-plus"></i>
          {{ $route.params.id ? "Save" : "Add" }}
        </button>
      </div>
    </div>
    <!-- /Form -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import Select2 from "v-select2-component";
export default {
  components: { Select2 },
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      employees: [],
      employeeName: "",
      years: [],
      dependents: [],
      enrolmentPeriodType: "Insurance",
      enrolmentPeriod: {
        Id: null,
        Instruction: "",
      },
      isNewEmployee: false,
      insuranceCategoryMapping: [],
      employeeInsuranceSubmissions: [],
      //form input
      userId: "",
      year: "",
      typeId: "",
      categoryId: "",
      noOfChildren: "",
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    isSpouseOnlySelected() {
      let selectedCategory = this.categories.find((c) => c.Id == this.categoryId);
      if (
        selectedCategory &&
        selectedCategory.Description.toLowerCase() == "spouse only"
      ) {
        return true;
      }
      return false;
    },
    isValid() {
      let isFormComplete = this.userId && this.year && this.typeId && this.categoryId;
      let isDependentComplete = true;
      for (let index in this.dependents) {
        var item = this.dependents[index];
        if (
          !item.MaritalStatus ||
          (item.Relationship == "Child" && item.FullTimeInput == "") ||
          (item.Relationship == "Child" && item.NationalServiceInput == "")
        ) {
          isDependentComplete = false;
          break;
        }
      }
      let errorMessage = this.getDependentsUnqualifiedErrorMessage();
      let isDependentQualified = !errorMessage;
      return isFormComplete && isDependentComplete && isDependentQualified;
    },
    types() {
      let types = [];
      if (this.$route.params.id) {
        let insuranceId = this.$route.params.id;
        let data = this.employeeInsuranceSubmissions.find((c) => c.Id == insuranceId);
        if (data)
          types.push({
            Id: data.InsuranceTypeId,
            Description: data.InsuranceType,
          });
      } else {
        if (this.userId && this.year) {
          let submittedTypeIds = this.employeeInsuranceSubmissions
            .filter((c) => c.UserId == this.userId && c.Year == this.year)
            .map((c) => c.InsuranceTypeId);
          types = this.insuranceCategoryMapping
            .filter((c) => !submittedTypeIds.includes(c.TypeId))
            .map((c) => ({ Id: c.TypeId, Description: c.TypeDescription }));
          types = [...new Map(types.map((item) => [item.Id, item])).values()];
        }
      }
      if (types == null || !types.length || !types.some((c) => c.Id == this.typeId))
        this.typeId = "";
      return types;
    },
    categories() {
      let categories = [];
      if (this.$route.params.id) {
        let insuranceId = this.$route.params.id;
        let data = this.employeeInsuranceSubmissions.find((c) => c.Id == insuranceId);
        if (data)
          categories.push({
            Id: data.EnrolmentCategoryId,
            Description: data.EnrolmentCategory,
          });
      } else {
        if (this.userId && this.year && this.typeId) {
          if (
            !this.employeeInsuranceSubmissions.some(
              (c) =>
                c.UserId == this.userId &&
                c.Year == this.year &&
                c.InsuranceTypeId == this.typeId
            )
          ) {
            categories = this.insuranceCategoryMapping
              .filter((c) => c.TypeId == this.typeId)
              .map((c) => ({ Id: c.CategoryId, Description: c.CategoryDescription }));
          }
        }
      }
      if (
        categories == null ||
        !categories.length ||
        !categories.some((c) => c.Id == this.categoryId)
      )
        this.categoryId = "";
      return categories;
    },
  },
  watch: {
    userId(val) {
      if (val) this.getEmployeeInsuranceSubmissions(val);
    },
  },
  methods: {
    getDependentsUnqualifiedErrorMessage() {
      let message = "";
      if (this.categoryId) {
        let map = this.insuranceCategoryMapping.find(
          (c) => c.CategoryId == this.categoryId
        );
        let desc = "";
        if (map) desc = map.CategoryDescription;
        if (desc) {
          desc = desc.trim().toLowerCase();
          let hasSpouse =
            this.dependents && this.dependents.some((c) => c.Relationship == "Spouse");
          let hasChildren =
            this.dependents && this.dependents.some((c) => c.Relationship == "Child");
          if (desc == "spouse only") {
            if (!hasSpouse) message = "No dependent details for Spouse";
          } else if (desc == "children only") {
            if (!hasChildren) message = "No dependent details for Children";
          } else if (desc == "spouse and children") {
            if (!hasSpouse && !hasChildren)
              message = "No dependent details for Spouse and Children";
            else if (!hasSpouse) message = "No dependent details for Spouse";
            else if (!hasChildren) message = "No dependent details for Children";
          }
        }
      }
      return message;
    },
    getEmployeInsuranceSelection() {
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.getEmployeInsuranceSelection(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            let data = response.data;
            this.employees = data.employees;
            this.employeeName = data.employeeName;
            this.insuranceCategoryMapping = data.insuranceCategoryMapping;
            this.userId = data.userId;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getEmployeeInsuranceSubmissions(userId) {
      let param = {
        Token: this.token,
        UserId: userId,
      };
      API.getEmployeeInsuranceSubmissions(param)
        .then((response) => {
          if (response.data.success) {
            this.employeeInsuranceSubmissions = response.data.records;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getYears() {
      let param = { Token: this.token };
      this.$store.state.isLoading = true;
      API.getYears(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.years = response.data.record;
            if (this.isNewEmployee) {
              this.year = response.data.record[0];
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getEmployeeDependentsByCategory() {
      if (!this.categoryId || !this.year || !this.userId) {
        this.dependents = null;
        return;
      }
      let param = {
        Token: this.token,
        UserId: this.userId,
        EnrolmentCategoryId: this.categoryId,
        Year: this.year,
      };
      API.getEmployeeDependentsByCategory(param)
        .then((response) => {
          if (response.data.success) {
            this.noOfChildren = response.data.noOfChildren;
            this.dependents = response.data.record;
            window.setTimeout(() => {
              let errorMessage = this.getDependentsUnqualifiedErrorMessage();
              if (errorMessage) alert(errorMessage);
            }, 100);
          } else console.log(response.data.message);
        })
        .catch((error) => {
          console.log(error.response.data.Message);
        });
    },
    getEmployeeInsuranceDetail() {
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.getEmployeeInsuranceDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.record) {
              let data = response.data.record;
              this.year = data.Year;
              this.years = [];
              this.years.push(data.Year);
              this.typeId = data.InsuranceTypeId;
              this.categoryId = data.EnrolmentCategoryId;
              this.noOfChildren = data.NumberOfChildren;
              this.dependents = response.data.dependents;
            } else {
              this.$router.replace({ name: "insuranceDependent" });
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      //validate missing dependent info
      for (let index in this.dependents) {
        var item = this.dependents[index];
        if (
          !item.Name ||
          !item.Relationship ||
          !item.Ic ||
          !item.Nationality ||
          !item.Gender ||
          !item.BirthdayDisplay ||
          !item.AgeDisplay
        ) {
          alert(
            "Dependent's information is incomplete. Please update in Employee Connect"
          );
          return;
        }
      }

      let param = {
        Token: this.token,
        Id: this.$route.params.id,
        UserId: this.userId,
        InsuranceTypeId: this.typeId,
        EnrolmentCategoryId: this.categoryId,
        Year: this.year,
        NumberOfChildren: !this.isSpouseOnlySelected ? this.noOfChildren : null,
        Dependents: this.dependents,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveEmployeeInsurance(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.$router.replace({ name: "insuranceDependent" });
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getEnrolmentPeriod() {
      let param = {
        Token: this.token,
        Type: this.enrolmentPeriodType,
        EmployeeInsuranceId: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.getEnrolmentPeriod(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (
              this.role == "employee" &&
              (!response.data.isEnrolmentOpen ||
                !response.data.isChangeAllowForEmployee) &&
              !response.data.isNewEmployee
            ) {
              this.$router.replace({ name: "insuranceDependent" });
              return;
            }

            if (response.data.record) this.enrolmentPeriod = response.data.record;
            if (response.data.isNewEmployee) {
              this.isNewEmployee = response.data.isNewEmployee;
            }
            if (this.enrolmentPeriod.Instruction) {
              this.enrolmentPeriod.Instruction = this.enrolmentPeriod.Instruction;
            } else {
              this.enrolmentPeriod.Instruction = "N.A.";
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
          this.getYears();
          if (this.$route.params.id) this.getEmployeeInsuranceDetail();
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    this.getEmployeInsuranceSelection();
    this.getEnrolmentPeriod();
  },
};
</script>

<style scoped>
.table {
  word-spacing: -3px;
  width: 1800px;
}

.table th {
  text-align: center;
  font-size: 14px;
}

.table td {
  font-size: 14px;
}

.action-column {
  width: 3%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Insurance/InsuranceAndDependent/InsuranceEdit.vue